import { render, staticRenderFns } from "./ServiceSearchDetail.vue?vue&type=template&id=2f0a26fa&scoped=true"
import script from "./ServiceSearchDetail.vue?vue&type=script&lang=js"
export * from "./ServiceSearchDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceSearchDetail.vue?vue&type=style&index=0&id=2f0a26fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a26fa",
  null
  
)

export default component.exports